import { render, staticRenderFns } from "./ChoiceTextbooks.vue?vue&type=template&id=6772d260&scoped=true"
import script from "./ChoiceTextbooks.vue?vue&type=script&lang=js"
export * from "./ChoiceTextbooks.vue?vue&type=script&lang=js"
import style0 from "./ChoiceTextbooks.vue?vue&type=style&index=0&id=6772d260&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772d260",
  null
  
)

export default component.exports